import React from 'react';
import { intlShape } from '../../../util/reactIntl';
import { array, bool, object } from 'prop-types';
import css from '../ListingPage.module.css';
import { H4 } from '../../../components';
import { propTypes } from '../../../util/types';
import { Swiper, SwiperSlide } from 'swiper/react';
import ListCardComponent from '../ListingCard';

const AuthorListings = ({
  intl,
  authorListings,
  authorListingsInProgress,
  authorListingsError,
  author,
  isVerified,
  rating,
  currentUserCurrency,
  exchangeRates,
  history,
  routes,
  queryID,
}) => {
  const hasListings = Array.isArray(authorListings) && authorListings.length > 0;
  const hasAuthor = author && author.id;

  if (!hasListings || !hasAuthor) return null;

  const profile = author.attributes?.profile || {};
  const { displayName, publicData } = profile;
  const city = publicData?.city;

  const authorListingsTitle = intl.formatMessage({ id: 'AuthorListings.title' }, { displayName });
  const viewMoreText = intl.formatMessage({ id: 'AuthorListings.viewMore' });

  const queryParams = new URLSearchParams();
  if (displayName) queryParams.set('name', displayName);
  if (city) queryParams.set('city', city);

  const linkProps = {
    name: 'ProfilePage',
    params: { id: author.id.uuid },
    to: { search: `?${queryParams.toString()}` },
  };

  return (
    <section className={css.similarItemSection} aria-label="Author listings section">
      <H4 className={css.itemTitle}>{authorListingsTitle}</H4>
      <p className={css.itemSubTitle}>Discover more rentals from this trusted owner.</p>

      <div className={css.similarItemCards}>
        {/* Uncomment if you want the "View more" link */}
        {/* {authorListings.length > 7 && (
          <NamedLink {...linkProps} className={css.viewMore}>
            {viewMoreText}
          </NamedLink>
        )} */}

        <Swiper
          spaceBetween={24}
          slidesPerView={3}
          navigation
          style={{ padding: '8px 0' }}
          breakpoints={{
            0: { slidesPerView: 1.1, spaceBetween: 12 },
            600: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {authorListings.map(l => (
            <SwiperSlide key={l.id.uuid}>
              <ListCardComponent
                rental={{
                  objectID: l.id.uuid,
                  title: l.attributes.title,
                  price: l.attributes.price,
                  user: {
                    displayName: l.author.attributes.profile.displayName,
                    publicData: l.author.attributes.profile.publicData,
                  },
                  publicData: l.attributes.publicData,
                  distance: l.attributes.distance,
                  _geoloc: l.attributes.geolocation,
                }}
                currentUserCurrency={currentUserCurrency}
                exchangeRates={exchangeRates}
                onClick={() => {}}
                history={history}
                routes={routes}
                queryID={queryID}
                additional={l.additional}
                isVerified={isVerified}
                author={author}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

AuthorListings.propTypes = {
  intl: intlShape.isRequired,
  authorListings: array.isRequired,
  authorListingsInProgress: bool,
  authorListingsError: propTypes.error,
  author: propTypes.user.isRequired,
  isVerified: bool,
  rating: propTypes.rating,
  currentUserCurrency: propTypes.currency,
  exchangeRates: propTypes.exchangeRates,
  history: object.isRequired,
  routes: object.isRequired,
  queryID: propTypes.uuid,
};

export default AuthorListings;
